<template>
		<div class="navbar bg-white p-0 sticky z-50 top-0 left-0 flex shadow">
		<div class="w-full flex justify-center  items-center">
			<div class="lg:flex cursor-pointer">
				<span class="text-lg font-bold cursor-pointer">
					<img src="@/assets/crystaSurelogo.svg" alt="" class="crystallineLogo" />
				</span>
			</div>
		</div>
	</div>
</template>
<style scoped>
.rounded-full:hover{
	box-shadow: 0px 0px 3px 4px rgba(0, 0, 0, 0.1);
}
.navbar{
	min-height: 2.5rem;
	height: 40px;
}
.crystallineLogo{
	width:120px;
}

.right-4{
	box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.08);
	/* background-color: red; */
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { emitter,toast } from '../main';
import { mapGetters } from 'vuex';
export default defineComponent({
	computed: {
		...mapGetters({ userInfo: 'userInfo' })
	},
	data():any {
		return {
			isToggle: true,
			isappsToggle:false,
			showBlock: false,
			displayName:'',
			timerInterval: null as any ,// Store interval reference,
			formattedRemainingTime: 'Loading...', // For displaying remaining time
			warningTime : `${process.env.VUE_APP_WARNING_TIME}`,
		};
	},
	mounted(){
		this.getAllTenants();
		this.updateRemainingTime(); // Start countdown timer
		emitter.on("apps",(isToggle:any)=>{
			this.showBlock = isToggle
			this.isappsToggle = isToggle;
		});
		emitter.on('session-extended', (newExpires: any) => {
			this.userInfo.expires = newExpires;
			this.updateRemainingTime();
		});
	},
	methods:{
		updateRemainingTime() {
			if (!this.userInfo.expires) return;

			const update = () => {
				const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
				const expiresTime = this.userInfo.expires; // Expiration time in seconds
				const remainingTime = expiresTime - currentTime; // Remaining time in seconds

				if (remainingTime <= 0) {
					this.formattedRemainingTime = 'Session Expired';
					clearInterval(this.timerInterval);
					emitter.emit('updateFormattedRemainingTime', this.formattedRemainingTime);
					return;
				}

				// Convert remaining time into hh:mm:ss format
				const hours = Math.floor(remainingTime / 3600);
				const minutes = Math.floor((remainingTime % 3600) / 60);
				const seconds = remainingTime % 60;

				this.formattedRemainingTime = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;


				const [hrs, mins, secs] = this.formattedRemainingTime.split(':').map(Number); // Split and convert to numbers
           	 	const totalSeconds = (hrs * 3600) + (mins * 60) + secs;
				const warningTimerSec = this.warningTime*60;
				if(totalSeconds <=warningTimerSec){
					emitter.emit('updateFormattedRemainingTime', this.formattedRemainingTime);
					emitter.emit('showPopup',true);

				}
			};
			update(); // Call once immediately
			this.timerInterval = setInterval(update, 1000); // Update every second
		},
		async getAllTenants() {
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/tenants/getAll`).then((res: any) => {
				this.allTenants = res.data;
				this.allTenants.filter((tenant:any) => {
					let userDomain = this.userInfo.email.substring(this.userInfo.email.lastIndexOf("@") + 1);
					let userOrgDetails = userDomain.split('.')[0];
					if(this.userInfo.organisationType==10701){
						this.displayName=this.userInfo.organizationName
					}
					if( tenant.tenantName!= undefined && userOrgDetails.toLowerCase() == tenant.tenantName.toLowerCase()){
						this.displayName= tenant.displayName
					}
					
				});
			});
		},
	}
});
</script>